import { Dispatch } from "redux";
import { setSecurityRulesRefreshResults, setSecurityRulesRefreshing } from "@redux/actions/security-rules-actions";
import { refreshSecurityRulesRequest } from "@requests/management-console/refresh-security-rules";
import { RefreshResult } from "@idw-types/common";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const refreshSecurityRulesReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<RefreshResult>> => {
    dispatch(setSecurityRulesRefreshResults(null, null));
    dispatch(setSecurityRulesRefreshing(true));
    const { data, error } = await refreshSecurityRulesRequest();

    const lastRefreshDate = new Date();

    if (data) {
        dispatch(setSecurityRulesRefreshResults(data, lastRefreshDate));
        return data;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.refreshSecurityRules.error.title,
                resources.requests.refreshSecurityRules.error.message
            );
        }
        dispatch(setSecurityRulesRefreshResults(null, lastRefreshDate));
        return null;
    }
};